<template>
  <el-form :model="loginModel" :rules="checkRules" ref="form1" label-position="left" label-width="0px" class="demo-ruleForm login-container">
    <h3 class="title">系统登录</h3>
    <el-form-item prop="account">
      <el-input type="text" v-model="loginModel.account" auto-complete="off" placeholder="账号"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <el-input type="password" v-model="loginModel.checkPass" auto-complete="off" placeholder="密码"></el-input>
    </el-form-item>
    <el-checkbox v-model="checked" class="remember">记住密码</el-checkbox>
    <el-form-item style="width:100%;">
      <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit" :loading="logining">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import md5 from "js-md5";
import { requestLogin } from "../api/adminApi";
import NProgress from "nprogress";
import config from "../api/config";
import routes from "../routes";
export default {
  data() {
    return {
      logining: false,
      loginModel: {
        account: "",
        checkPass: ""
      },
      checkRules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      checked: false
    };
  },
  methods: {
    compileStr(code) {
      var c = String.fromCharCode(code.charCodeAt(0) + code.length);
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
      }
      return escape(c);
    }, //加密函数
    uncompileStr(code) {
      code = unescape(code);
      var c = String.fromCharCode(code.charCodeAt(0) - code.length);
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
      }
      return c;
    }, //解密函数
    //设置cookie
    setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie =
        cname + "=" + this.compileStr(escape(cvalue)) + "; " + expires;
    },
    //获取cookie
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) {
          var cnameValue = this.uncompileStr(
            unescape(c.substring(name.length, c.length))
          );
          return cnameValue;
        }
      }
      return "";
    },
    //清除cookie
    clearCookie(cname) {
      this.setCookie(cname, "", -1);
    },
    handleReset() {
      this.$refs.form1.resetFields();
    },
    handleSubmit(ev) {
      this.$refs.form1.validate(valid => {
        if (valid) {
          this.logining = true;
          NProgress.start();
          var md5Passwd = md5(this.loginModel.checkPass);
          var loginParams = {
            Account: this.loginModel.account,
            Passwd: md5Passwd
          };
          requestLogin(loginParams).then(res => {
            this.logining = false;
            NProgress.done();
            let data = res.data;
            if (data.StateCode !== 0) {
              this.$notify({
                title: "错误",
                message: res.data.StateMsg,
                type: "error"
              });
            } else {
              if (this.checked) {
                this.$nextTick(function() {
                  this.setCookie(
                    "erpcustomername",
                    this.loginModel.account,
                    15
                  );
                  this.setCookie(
                    "erpcustomerpass",
                    this.loginModel.checkPass,
                    15
                  );
                });
              } else {
                this.clearCookie("erpcustomername");
                this.clearCookie("erpcustomerpass");
              }
              sessionStorage.setItem("user", JSON.stringify(data.Data));
              var user = sessionStorage.getItem("user");
              user = JSON.parse(user);
              var userMsg = { Sid: user.Sid, Session: user.Session };
              config.params = userMsg;
              var MenuList = user.MenuList;
              if (MenuList.length == 0) {
                this.$notify({
                  title: "错误",
                  message: "该账号暂无任何权限，无法进入系统",
                  type: "error"
                });
              } else {
                var obj = MenuList[0].EachList[0].MenuId;
                if (obj != "" || obj != undefined) {
                  for (var i = 0; i < routes.length; i++) {
                    var aj = routes[i];
                    var childRoutes = aj.children;
                    if (childRoutes) {
                      for (let j = 0; j < childRoutes.length; j++) {
                        if (childRoutes[j].MenuId == obj) {
                          this.$router.push({ path: childRoutes[j].path });
                        } else {
                        }
                      }
                    }
                  }
                } else {
                  alert("暂未拥有任何权限");
                }
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  created() {
    if (
      this.getCookie("erpcustomername") != "" &&
      this.getCookie("erpcustomerpass") != ""
    ) {
      this.loginModel.account = this.getCookie("erpcustomername");
      this.loginModel.checkPass = this.getCookie("erpcustomerpass");
      this.checked = true;
    }
    $(document).keydown(event => {
      var eCode = event.keyCode
        ? event.keyCode
        : event.which ? event.which : event.charCode;
      if (eCode == 13) {
        this.handleSubmit();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin-bottom: 20px;
  background-color: #f9fafc;
  margin: 180px auto;
  border: 2px solid #8492a6;
  width: 350px;
  padding: 35px 35px 15px 35px;
  .title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// Login.vue?007e8b9a